// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acts-rules-orders-update-section .custom-container .content-section {
  background: #E0E7FF;
  padding: 4rem 2rem;
  min-height: 55vh;
}
.acts-rules-orders-update-section .custom-container .content-section .page-title {
  font-size: 2.2rem;
  text-align: center;
  color: #08245A;
}
.acts-rules-orders-update-section .custom-container .content-section .page-title::after {
  content: "";
  display: block;
  height: 8px;
  width: 60px;
  background: #08245A;
  margin: 0.7rem auto 0;
  border-radius: 20px;
}
.acts-rules-orders-update-section .custom-container .content-section .content-body {
  max-width: 1280px;
  margin: 2rem auto 0;
  border-radius: 3px;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.acts-rules-orders-update-section .custom-container .content-section .content-body .custom-act-rules-order-card {
  background: #fff;
  height: 420px;
  max-width: 295px;
  padding: 1rem 1rem 0;
  border-radius: 12px;
  margin-bottom: 2.5rem;
  transition: 0.5s;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.acts-rules-orders-update-section .custom-container .content-section .content-body .custom-act-rules-order-card .card-header {
  background: rgba(53, 78, 128, 0.9);
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 100%);
}
.acts-rules-orders-update-section .custom-container .content-section .content-body .custom-act-rules-order-card .card-header img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}
.acts-rules-orders-update-section .custom-container .content-section .content-body .custom-act-rules-order-card .card-body {
  height: calc(385px - 1rem - 200px - 40px);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.25rem 0;
}
.acts-rules-orders-update-section .custom-container .content-section .content-body .custom-act-rules-order-card .card-body .title {
  font-weight: 500;
  font-size: 1rem;
  color: #08245A;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.acts-rules-orders-update-section .custom-container .content-section .content-body .custom-act-rules-order-card .custom-card-footer {
  background: #fff;
  height: 40px;
  padding-top: 7px;
}
.acts-rules-orders-update-section .custom-container .content-section .content-body .custom-act-rules-order-card .custom-card-footer .pdf-icon {
  height: 22px;
  width: 22px;
  object-fit: contain;
}
.acts-rules-orders-update-section .custom-container .content-section .content-body .custom-act-rules-order-card .custom-card-footer .download-icon {
  color: #354e80;
  font-size: 25px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/adminPages/actRulesOrder/style.scss","webpack://./src/assets/css/common/_variables.scss"],"names":[],"mappings":"AAII;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AAHN;AAKM;EACE,iBCGK;EDFL,kBAAA;EACA,cAAA;AAHR;AAKQ;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAHV;AAOM;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iDAAA;AALR;AAOQ;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,2CAAA;AALV;AAOU;EACE,kCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kDAAA;AALZ;AAOY;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;AALd;AASU;EACE,yCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAPZ;AASY;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iDAAA;EAEA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA,EAAA,4BAAA;EACA,aAAA;EACA,4BAAA;AARd;AAYU;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;AAVZ;AAYY;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AAVd;AAaY;EACE,cAAA;EACA,eAAA;AAXd","sourcesContent":["@import \"./src/assets/css/common/variables\";\r\n\r\n.acts-rules-orders-update-section{\r\n  .custom-container {\r\n    .content-section {\r\n      background: #E0E7FF;\r\n      padding: 4rem 2rem;\r\n      min-height: 55vh;\r\n\r\n      .page-title {\r\n        font-size: $page-title;\r\n        text-align: center;\r\n        color: #08245A;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          display: block;\r\n          height: 8px;\r\n          width: 60px;\r\n          background: #08245A;\r\n          margin: .7rem auto 0;\r\n          border-radius: 20px;\r\n        }\r\n      }\r\n\r\n      .content-body {\r\n        max-width: 1280px;\r\n        margin: 2rem auto 0;\r\n        border-radius: 3px;\r\n        font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n\r\n        .custom-act-rules-order-card {\r\n          background: #fff;\r\n          height: 420px;\r\n          max-width: 295px;\r\n          padding: 1rem 1rem 0;\r\n          border-radius: 12px;\r\n          margin-bottom: 2.5rem;\r\n          transition: 0.5s;\r\n          box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n\r\n          .card-header {\r\n            background: rgba(53, 78, 128, 0.90);\r\n            height: 200px;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            border-radius: 12px;\r\n            clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 100%);\r\n\r\n            img {\r\n              width: 100px;\r\n              height: 100px;\r\n              object-fit: contain;\r\n              filter: brightness(0) invert(1);\r\n            }\r\n          }\r\n\r\n          .card-body {\r\n            height: calc(385px - 1rem - 200px - 40px);\r\n            text-align: center;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            padding: 1.25rem 0;\r\n\r\n            .title {\r\n              font-weight: 500;\r\n              font-size: 1rem;\r\n              color: #08245A;\r\n              font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n\r\n              overflow: hidden;\r\n              text-overflow: ellipsis;\r\n              display: -webkit-box;\r\n              -webkit-line-clamp: 2; /* number of lines to show */\r\n              line-clamp: 2;\r\n              -webkit-box-orient: vertical;\r\n            }\r\n          }\r\n\r\n          .custom-card-footer {\r\n            background: #fff;\r\n            height: 40px;\r\n            padding-top: 7px;\r\n\r\n            .pdf-icon{\r\n              height: 22px;\r\n              width: 22px;\r\n              object-fit: contain;\r\n            }\r\n\r\n            .download-icon {\r\n              color: #354e80;\r\n              font-size: 25px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Color palette\r\n$color-blue-light: #d0dbff;\r\n$color-blue: #354e80;\r\n$color-blue-dark: #1c2f56;\r\n\r\n$color-sky: #e0e7ff;\r\n\r\n$color-yellow-light: #fffdef;\r\n$color-yellow: #fae205;\r\n\r\n$color-black-30: #e1e2e2;\r\n\r\n$section-heading-font-size: 2.1rem;\r\n$page-title: 2.2rem;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
